import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { collection, getDocs, query } from 'firebase/firestore';
import { db } from '../../firebase/config';

// Initial state
const initialState = {
  advisors: [],
  loading: false,
  error: null
};

// Async thunk to fetch advisors from Firebase
export const fetchAdvisors = createAsyncThunk(
  'advisors/fetchAdvisors',
  async (_, { rejectWithValue }) => {
    try {
      console.log('Fetching advisors from myelinAdvisors collection...');
      
      const q = query(collection(db, 'myelinAdvisors'));
      const snapshot = await getDocs(q);
      
      console.log('Raw advisor documents:', snapshot.docs.length);
      
      const advisors = snapshot.docs.map(doc => {
        const data = doc.data();
        console.log('Advisor data:', data);
        return {
          id: doc.id,
          ...data
        };
      });
      
      // Sort by serial number if available
      const sortedAdvisors = advisors.sort((a, b) => (a.serial || 0) - (b.serial || 0));
      
      console.log('Processed advisors:', sortedAdvisors);
      return sortedAdvisors;
    } catch (error) {
      console.error('Error fetching advisors:', error);
      return rejectWithValue(error.message);
    }
  }
);

// Advisors slice
const advisorsSlice = createSlice({
  name: 'advisors',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdvisors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdvisors.fulfilled, (state, action) => {
        state.loading = false;
        state.advisors = action.payload;
        state.error = null;
      })
      .addCase(fetchAdvisors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearError } = advisorsSlice.actions;
export default advisorsSlice.reducer;